import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar";
import {
  Container,
  Grid,
  Typography,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Slider,
  Modal,
  InputAdornment,
  TextField,
  Box,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import FindExpertCard from "./components/FindExpertCard";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import GoogleMapReact from "google-map-react";
import { getAllServiceProvidersWithCategory } from "../../apis";
import "../../App.css";
import axios from "axios";

const style = {
  position: "absolute",
  top: "45%",
  left: "55%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

let circle;
const FindExperts = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const [expertsData, setExpertsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [radius, setRadius] = useState(10);
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [zoom, setZoom] = useState(11);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let response = await getAllServiceProvidersWithCategory(
        location.state.title
      );
      setExpertsData(response.data.userInfo);
      setLoading(false);
    };
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/login");
    } else {
      fetchData();
    }
  }, []);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setLatitude(position.coords.latitude);
      setLongitude(position.coords.longitude);
      axios
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyCGuRwgYRduNFkJtak6ID1PWs82gMkRaDQ`
        )
        .then((res) =>
          //console.log(res)
          setValue(res.data.results[0].address_components[2].short_name, false)
        );
    });
  }, []);

  const km = [
    // { value: 1, label: "1 kilometer" },
    // { value: 2, label: "2 kilometers" },
    { value: 5, label: "5 miles" },
    { value: 10, label: "10 miles" },
    { value: 20, label: "20 miles" },
    { value: 40, label: "40 miles" },
    { value: 60, label: "60 miles" },
    { value: 80, label: "80 miles" },
    { value: 100, label: "100 miles" },
    // { value: 250, label: "250 kilometers" },
    // { value: 500, label: "500 kilometers" },
  ];

  const handleRadiusChange = (e) => {
    setRadius(e.target.value);
    circle.setRadius(e.target.value * 1000);
    if (e.target.value <= 10) {
      setZoom(11);
    }
    if (e.target.value > 10 && e.target.value <= 20) {
      setZoom(10);
    }
    if (e.target.value > 20 && e.target.value <= 40) {
      setZoom(9);
    }
    if (e.target.value > 40 && e.target.value <= 60) {
      setZoom(8);
    }
    if (e.target.value > 60 && e.target.value <= 100) {
      setZoom(7);
    }
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      setAddress(description);
      clearSuggestions();
      circle.setRadius(radius * 1000);

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        // console.log("📍 Coordinates: ", { lat, lng });
        setLatitude(lat);
        setLongitude(lng);
        circle.setCenter({ lat: lat, lng: lng });
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        // <li key={place_id} onClick={handleSelect(suggestion)}>
        //   <strong>{main_text}</strong> <small>{secondary_text}</small>
        // </li>
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #EEEBEF",
            cursor: "pointer",
          }}
          onClick={handleSelect(suggestion)}
        >
          <Typography>
            {main_text}, {secondary_text}
          </Typography>
        </div>
      );
    });

  const apiIsUpdated = (map, maps) => {
    circle = new maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.3,
      map,
      center: { lat: latitude, lng: longitude },
      radius: radius * 1000,
    });
  };

  const handleClose = () => setOpen(false);

  function distance(lat1, lon1, lat2, lon2, unit) {
    if (lat1 == lat2 && lon1 == lon2) {
      return 0;
    } else {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") {
        dist = dist * 1.609344;
      }
      if (unit == "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }
  }

  const applyRadiusFilterHandler = async () => {
    let filteredData = [];
    let result = await getAllServiceProvidersWithCategory(location.state.title);
    result.data.userInfo.map((expert) => {
      let response = distance(
        latitude,
        longitude,
        expert.serviceProviderInfo.personalInfo.latitude,
        expert.serviceProviderInfo.personalInfo.longitude,
        "K"
      );
      if (response <= radius) {
        filteredData.push(expert);
      }
    });

    setExpertsData(filteredData);
    setOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        // onClose={handleCloseConfirmation}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack justifyContent="center" alignItems="center">
            <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
              Change Location
            </Typography>
          </Stack>
          <Stack className="mt-10">
            <Typography className="ammanat-darker-gray">Location</Typography>
            <TextField
              required
              size="small"
              variant="outlined"
              className="w-100"
              placeholder="Enter your address"
              value={value}
              disabled={!ready}
              onChange={(e) => {
                setAddress(e.target.value);
                setValue(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FmdGoodOutlinedIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Stack>
            {/* We can use the "status" to decide whether we should display the dropdown or not */}
            {status === "OK" && (
              <div
                style={{
                  border: "1px solid #EEEBEF",
                  borderRadius: "6px",
                  background: "white",
                  position: "absolute",
                  zIndex: "100",
                  width: "89%",
                }}
                className="mb-16"
              >
                {renderSuggestions()}
              </div>
            )}
          </Stack>
          <Stack className="mt-10">
            <Typography className="ammanat-darker-gray">Radius</Typography>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={radius}
                onChange={(e) => handleRadiusChange(e)}
                // displayEmpty
                // placeholder="Select Category"
              >
                {km.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack className="mt-10" style={{ height: "350px" }}>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyCGuRwgYRduNFkJtak6ID1PWs82gMkRaDQ",
              }}
              center={{
                lat: latitude,
                lng: longitude,
              }}
              defaultZoom={11}
              zoom={zoom}
              draggable={false}
              options={{
                disableDefaultUI: true,
              }}
              yesIWantToUseGoogleMapApiInternals={true}
              onGoogleApiLoaded={({ map, maps }) => apiIsUpdated(map, maps)}
            >
              <FmdGoodIcon
                lat={latitude}
                lng={longitude}
                className="default-color"
              />
            </GoogleMapReact>
          </Stack>
          <Stack
            className="mt-10"
            direction="row"
            spacing={3}
            justifyContent="flex-end"
          >
            <Button
              variant="outlined"
              className="default-border default-color"
              style={{ textTransform: "capitalize" }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="primary-button"
              style={{ textTransform: "capitalize" }}
              onClick={applyRadiusFilterHandler}
            >
              Apply
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Navbar />
      <Grid container>
        <Grid item sm={3}>
          <Container style={{ marginLeft: "60px" }}>
            <Stack
              className="mt-10 mb-10"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography>Filters</Typography>
              <Typography className="default-color">Clear All</Typography>
            </Stack>
            <div className="filter-container">
              <div className="mb-10">
                <Typography style={{ fontWeight: "bold" }}>
                  Sub Category
                </Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Movers"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Delivery"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Packaging"
                    className="ammanat-darker-gray"
                  />
                </FormGroup>
              </div>
              <div className="mb-10">
                <Typography style={{ fontWeight: "bold" }}>Rating</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label="4 Star and Above"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="3 Star and Above"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="2 Star and Above"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="1 Star and Above"
                    className="ammanat-darker-gray"
                  />
                </FormGroup>
              </div>
              <div className="mb-10">
                <Typography style={{ fontWeight: "bold" }}>Distance</Typography>
                <Typography
                  className="mt-5 default-color"
                  style={{ fontWeight: "bold", cursor: "pointer" }}
                  onClick={() => setOpen(true)}
                >
                  {value} | {radius} miles
                </Typography>
              </div>
              <div className="mb-10">
                <Typography style={{ fontWeight: "bold" }}>
                  Certification
                </Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Yes"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="No"
                    className="ammanat-darker-gray"
                  />
                </FormGroup>
              </div>
              <div className="mb-10">
                <Typography style={{ fontWeight: "bold" }}>
                  Type of Account
                </Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Personal"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Sole Trader"
                    className="ammanat-darker-gray"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Company"
                    className="ammanat-darker-gray"
                  />
                </FormGroup>
              </div>
            </div>
          </Container>
        </Grid>
        <Grid item sm={7}>
          <Container style={{ marginLeft: "120px" }}>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold" }}
              className="mt-10 mb-10"
            >
              {location.state.title}
            </Typography>
            <div className="findExpert-container">
              {!loading && expertsData.length ? (
                expertsData.map((item) => (
                  <FindExpertCard
                    name={item.serviceProvider.fullName}
                    country={item.serviceProviderInfo.personalInfo.address}
                    image={item.serviceProviderInfo.personalInfo.image[0]}
                    skills={item.serviceProviderInfo.expertise.skills}
                    id={item.serviceProvider._id}
                    rating={item.serviceProviderInfo.personalInfo.avgRating}
                    certifications={
                      item.serviceProviderInfo.documents.certificationData
                    }
                  />
                ))
              ) : !loading && !expertsData.length ? (
                <Typography>
                  There are no Experts regarding this category near you.
                </Typography>
              ) : (
                <></>
              )}
            </div>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default FindExperts;
